import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { createLocationMarker } from 'redux/location-links/actions';

import Button from 'components/elements/buttons/Button';

import GooglePlacesAutocomplete,
  { geocodeByPlaceId, getLatLng } from 'react-google-places-autocomplete';

import { GOOGLE_MAPS_API_KEY } from 'utils/restapi';

import './AddLocationMarkerForm.css';


function AddLocationMarkerForm(props) {
  const { linkItem, createLocationMarker } = props;

  const { t } = useTranslation();

  const [currentValue, setCurrentValue] = useState(null);
  const [currentAddress, setCurrentAddress] = useState(null);
  const [currentLat, setCurrentLat] = useState(null);
  const [currentLng, setCurrentLng] = useState(null);

  useEffect(() => {
    if (currentValue) {
      geocodeByPlaceId(currentValue.value.place_id)
      .then(results => {
        setCurrentAddress(results[0].formatted_address);
        return getLatLng(results[0]);
      })
      .then(({ lat, lng }) => {
        setCurrentLat(lat);
        setCurrentLng(lng);
      })
      .catch(error => console.error(error));
    }
  }, [currentValue]);

  return (
    <div className="add-location-marker-form__component">
      <div className="field-wrapper">
        <GooglePlacesAutocomplete
          apiKey={GOOGLE_MAPS_API_KEY}
          selectProps={{
            value: currentValue,
            onChange: setCurrentValue,
            placeholder: t("Type or paste location address"),
          }}
        />
      </div>
      <Button
        small
        onClick={() => {
          createLocationMarker({
            map: linkItem.id,
            title: currentAddress,
            lat: currentLat.toFixed(6),
            lng: currentLng.toFixed(6),
          });
          setCurrentValue(null);
        }}
        disabled={!currentLat || !currentLng || !currentAddress}
      >
        {t("Add")}
      </Button>
    </div>
  );
}

AddLocationMarkerForm.propTypes = {
  createLocationMarker: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
};

export default connect(
  null,
  {
    createLocationMarker,
  },
)(AddLocationMarkerForm);
